import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Mic, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@shruti.com");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[var(--c-bg)]">
      <div className="hidden lg:flex flex-col justify-between bg-[var(--c-primary)] text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 bg-noise opacity-30" />
        <div className="relative flex items-center gap-3">
          <span className="grid place-items-center h-12 w-12 rounded-full border border-[var(--c-accent)]"><Mic className="h-5 w-5" /></span>
          <div>
            <div className="font-heading text-2xl font-bold">শ্রুতি</div>
            <div className="font-body text-[10px] tracking-[0.3em] text-[var(--c-accent)]">SHRUTI · ADMIN</div>
          </div>
        </div>
        <div className="relative">
          <h1 className="font-heading text-4xl font-bold leading-tight">কনটেন্ট ম্যানেজমেন্ট<br />ড্যাশবোর্ড</h1>
          <p className="font-body text-white/70 mt-4 max-w-sm">ওয়েবসাইটের প্রতিটি শব্দ, ছবি ও বিভাগ এখান থেকেই নিয়ন্ত্রণ করুন — কোনো কোড ছাড়াই।</p>
        </div>
        <p className="relative font-body text-sm text-white/50">© ২০২৬ শ্রুতি</p>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm">
          <h2 className="font-heading text-3xl font-bold text-[var(--c-primary)]">লগইন করুন</h2>
          <p className="font-body text-stone-500 mt-2">অ্যাডমিন প্যানেলে প্রবেশ করুন</p>
          {err && <div data-testid="login-error" className="mt-5 rounded-lg bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-3">{err}</div>}
          <div className="space-y-4 mt-6">
            <div>
              <label className="block text-sm font-medium text-stone-600 mb-1.5">ইমেইল</label>
              <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-lg border border-stone-200 px-4 py-3 focus:outline-none focus:border-[var(--c-secondary)]" />
            </div>
            <div>
              <label className="block text-sm font-medium text-stone-600 mb-1.5">পাসওয়ার্ড</label>
              <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="w-full rounded-lg border border-stone-200 px-4 py-3 focus:outline-none focus:border-[var(--c-secondary)]" />
            </div>
            <button data-testid="login-submit" disabled={busy} className="w-full rounded-full bg-[var(--c-primary)] text-white font-medium py-3 hover:bg-[var(--c-secondary)] transition-colors disabled:opacity-60 inline-flex items-center justify-center gap-2">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} প্রবেশ করুন
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
